import React, { Component } from 'react';
import { HeartIcon, BarChart2Icon, AlertTriangleIcon, TagIcon, XIcon } from 'lucide-react';
export type TagVariant = 'mood' | 'pacing' | 'warning' | 'neutral';
interface ReviewTagChipProps {
  label: string;
  variant?: TagVariant;
  onClick?: (label: string) => void;
  onRemove?: (label: string) => void;
  className?: string;
}
export const ReviewTagChip: React.FC<ReviewTagChipProps> = ({
  label,
  variant = 'neutral',
  onClick,
  onRemove,
  className = ''
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'mood':
        return 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300 hover:bg-rose-200 dark:hover:bg-rose-900/50';
      case 'pacing':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900/50';
      case 'warning':
        return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/50';
      case 'neutral':
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700';
    }
  };
  const getIcon = () => {
    const iconProps = {
      className: 'h-3 w-3 mr-1 flex-shrink-0'
    };
    switch (variant) {
      case 'mood':
        return <HeartIcon {...iconProps} data-id="element-3368" data-mp="nx2vt4fst8yi" />;
      case 'pacing':
        return <BarChart2Icon {...iconProps} data-id="element-3369" data-mp="91d3kok0rzlc" />;
      case 'warning':
        return <AlertTriangleIcon {...iconProps} data-id="element-3370" data-mp="937tyie28jwt" />;
      case 'neutral':
      default:
        return <TagIcon {...iconProps} data-id="element-3371" data-mp="e1hpiu3p5miy" />;
    }
  };
  const isClickable = !!onClick;
  const Component = isClickable ? 'button' : 'span';
  return <Component onClick={() => onClick?.(label)} className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium transition-colors ${getVariantStyles()} ${isClickable ? 'cursor-pointer' : ''} ${className}`} data-id="element-3372" data-mp="4z8e820ltp4i">
      {getIcon()}
      <span className="truncate max-w-[150px]" data-id="element-3373" data-mp="1zd106v0176te">{label}</span>
      {onRemove && <button onClick={e => {
      e.stopPropagation();
      onRemove(label);
    }} className="ml-1 p-0.5 rounded-full hover:bg-black/10 dark:hover:bg-white/10 transition-colors" aria-label={`Remove ${label} tag`} data-id="element-3374" data-mp="1wznp40k4iggy">
          <XIcon className="h-3 w-3" data-id="element-3375" data-mp="1izwf0awq9k88" />
        </button>}
    </Component>;
};